import React, { Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Drawer, Box } from "@mui/material";
import { useMenu } from "../Menu/MenuContext";
import MenuHeader from "../Menu/MenuHeader";
import MenuContent from "../Menu/MenuContent";
import Loading from "../Loading/Loading";
import routes from "../../config/routes";

export const DRAWER_WIDTH = 260;

export const AppLayout: React.FC = () => {
  const { isMenuOpen, isDesktop, toggleThis } = useMenu();
  const location = useLocation();

  const isAuthRoute =
    location.pathname === "/signin" ||
    location.pathname === "/signup" ||
    location.pathname === "/password_reset" ||
    location.pathname === "/logout" ||
    location.pathname === "/";

  const effectiveDrawerOpen = !isAuthRoute && isMenuOpen;

  return (
    <Box sx={{ display: "flex", width: "100vw", height: "100vh", overflow: "hidden" }}>
      {/* Desktop Persistent / Mobile Temporary Drawer */}
      <Drawer
        variant={isDesktop ? "persistent" : "temporary"}
        open={effectiveDrawerOpen}
        onClose={() => toggleThis("isMenuOpen", false)}
        sx={{
          width: effectiveDrawerOpen ? DRAWER_WIDTH : 0,
          flexShrink: 0,
          transition: (theme) =>
            theme.transitions.create("width", {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
          "& .MuiDrawer-paper": {
            width: DRAWER_WIDTH,
            boxSizing: "border-box",
            borderRight: "1px solid",
            borderColor: "divider",
            boxShadow: isDesktop && effectiveDrawerOpen ? "2px 0 12px rgba(0, 0, 0, 0.04)" : "none",
            bgcolor: "background.paper",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <MenuHeader />
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(0, 0, 0, 0.12)",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "transparent",
            },
          }}
        >
          <MenuContent />
        </Box>
      </Drawer>

      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: "100vh",
          overflow: "auto",
          position: "relative",
          bgcolor: "background.default",
          transition: (theme) =>
            theme.transitions.create(["margin", "width"], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
        }}
      >
        <Suspense fallback={<Loading />}>
          <Routes>
            {routes.map((route, index) => (
              <Route
                key={`route-${route.path || index}`}
                path={route.path}
                element={route.element}
              />
            ))}
          </Routes>
        </Suspense>
      </Box>
    </Box>
  );
};

export default AppLayout;
